import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { busyTimeApi } from './BusyTimeApi';
import { busyTimeActions } from './BusyTimeSlice';
import { HTTP_RESPONSE_STATUS } from '../../../../setup/constants/Http';
import { ToastDefaultConfig } from '../../../../setup/toast/ToastConfig';
import { SearchBusyTimeRequest, BusyTimeListResponse, BusyTimeListItem } from '../models';
import { ListResponse } from '../../../../setup/axios/HttpResponse';

function* fetchBusyTimeList(action: PayloadAction<SearchBusyTimeRequest>): Generator<any, void, any> {
  try {
    const response: ListResponse<BusyTimeListItem> = yield call(busyTimeApi.searchBusyTime, action.payload);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      // Transform the response to BusyTimeListResponse format
      const transformedResponse: BusyTimeListResponse = {
        data: response.data.rows || [],
        total: response.data.pagination?.totalRows || 0,
      };
      yield put(busyTimeActions.fetchBusyTimeListSuccess(transformedResponse));
    } else {
      toast.error(response.message || 'Failed to fetch busy time list', ToastDefaultConfig());
      yield put(busyTimeActions.fetchBusyTimeListFailed(response.message || 'Failed to fetch busy time list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch busy time list', ToastDefaultConfig());
    yield put(busyTimeActions.fetchBusyTimeListFailed(error.message || 'Failed to fetch busy time list'));
  }
}

export function* busyTimeSaga() {
  yield takeLatest(busyTimeActions.fetchBusyTimeListStart.type, fetchBusyTimeList);
}

export default busyTimeSaga;

